<template>
  <wrap-container>
    <section-label v-if="title" :value="title" />
    <custom-select
      :label="label"
      :items="items"
      v-model="model.item"
      :required="true"
      @input="change"
    />
  </wrap-container>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import CustomSelect from "@/components/core/custom/CustomSelect";
import SectionLabel from "@/components/core/SectionLabel";
export default {
  components: {
    WrapContainer,
    CustomSelect,
    SectionLabel
  },
  props: {
    label: String,
    title: String
  },
  data() {
    return {
      model: {
        /** Valor por default viene del router */
        item: this.$route.meta.levels[1]
      }
    };
  },
  computed: {
    items() {
      let items = [];
      let segments = this.config.vistas[this.$route.meta.levels[0]].items;
      for (const key in segments) {
        // eslint-disable-next-line no-prototype-builtins
        if (segments.hasOwnProperty(key)) {
          const element = segments[key];
          items.push({
            label: element.label,
            value: element.routeName
          });
        }
      }
      return items;
    }
  },
  methods: {
    change(ruta) {
      if (ruta && this.$route.name !== ruta) {
        this.$router.push({ name: ruta });
      }
    }
  },
  watch: {
    $route(to) {
      this.model.item = to.meta.levels ? to.meta.levels[1] : null;
    }
  }
};
</script>
